import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    // Mỗi khi ngôn ngữ thay đổi, cập nhật lại nhãn
    this.translate.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.getTranslations();
  }

  getTranslations() {
    this.itemsPerPageLabel = this.translate.instant('common.PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('common.PAGINATOR.NEXT_PAGE');
    this.previousPageLabel = this.translate.instant('common.PAGINATOR.PREVIOUS_PAGE');
    this.firstPageLabel = this.translate.instant('common.PAGINATOR.FIRST_PAGE');
    this.lastPageLabel = this.translate.instant('common.PAGINATOR.LAST_PAGE');
    this.changes.next(); // Thông báo cho Paginator vẽ lại giao diện
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.translate.instant('common.PAGINATOR.OF')} ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} ${this.translate.instant('common.PAGINATOR.OF')} ${length}`;
  };
}